import React, { useState } from 'react';
import CategoryMenu from './CategoryMenu.jsx';

function MobileMenu({ frameInfo, productTileClick }) {

    const [open, setOpen] = useState(false);
   
    return (
        <div id="benefit-products-mobile-menu-container">
            <img onClick={() => setOpen(! open)} 
                 src={getStaticFile("/images/svg/Dropdown.svg")}
                 className={open ? 'open' : ''}
            />

            { open && 
                <div className={`benefit-products-mobile-menu ${SG.BG_NAV}`}>
                    <CategoryMenu sectionDetails={frameInfo['benefitDetails']} productTileClick={productTileClick}></CategoryMenu>
                </div>
            }
        </div>
    )
}

export default MobileMenu;
